<template>
  <div class="c-group-table">
    <!-- <Spin size="large" fix v-if="value"></Spin> -->
    <el-table
      ref="table"
      :height="height"
      row-key="adGroupId"
      class="summary-el-table-styles common-el-table-styles"
      v-loading="value"
      :data="data"
      :summary-method="getSummaries"
      show-summary
      stripe
      border
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <i-Switch v-model="scope.row.status" @on-change="changeActive(scope.row)" :loading="scope.row.optLoading" size="small" />
            <Button v-if="scope.row.origin" type="primary" size="small" shape="circle">内</Button>
          </div>
          <div v-else-if="col.key === 'adGroupName'">
            <div v-if="scope.row.edit">
              <el-input placeholder="" v-model="scope.row.newAdGroupName" style="width: 150px"></el-input>
              <Button type="primary" :loading="saving" size="small" @click="edit(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row)" style="padding: 0 3px">取消</Button>
            </div>
            <div v-else>
              <a @click.prevent="clickGroup(scope.row)">{{ scope.row.adGroupName }}</a>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row)"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" :disabled="media === 6" @click="editClick(scope.row)">修改</el-button>
            <el-button
              type="text"
              size="small"
              class="m-control-btn"
              :disabled="media === 6 || media === 45 || media === 10 || media === 16"
              @click="copyClick(scope.row)"
              >复制</el-button
            >
          </div>
          <!-- 腾讯广告/快手/头条 -->
          <div v-else-if="[16, 32, 10, 6].includes(media) && col.key === 'budget'">
            <Row v-if="scope.row.editBudget">
              <Col span="11">
                <RadioGroup v-model="scope.row.budgetFlag" vertical>
                  <Radio :label="0"><span>不限</span></Radio>
                  <Radio :label="1">
                    <el-input
                      placeholder=""
                      v-model.trim="scope.row.newbudget"
                      :disabled="!scope.row.budgetFlag"
                      style="width: 50px"
                      @blur="inputTrim('newbudget', scope.row)"
                    ></el-input>
                  </Radio>
                </RadioGroup>
              </Col>
              <Col span="13" style="padding-top: 33px">
                <Button type="primary" :loading="saving" size="small" @click="editBudget(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
              </Col>
            </Row>
            <div v-else>
              <span v-if="scope.row.budget > 0">{{ scope.row.budget | toThousands }}</span>
              <span v-else>不限</span>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row, 'editBudget', 'budget')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <!-- 百度 -->
          <div v-else-if="media === 45 && col.key === 'budget'">
            <Row v-if="scope.row.editBudget">
              <Col span="11">
                <RadioGroup v-model="scope.row.budgetFlag" vertical>
                  <Radio :label="0"><span>不限</span></Radio>
                  <Radio :label="1">
                    <el-input
                      placeholder=""
                      v-model.trim="scope.row.newbudget"
                      @blur="inputTrim('newbudget', scope.row, true)"
                      :disabled="!scope.row.budgetFlag"
                      style="width: 50px"
                    ></el-input>
                  </Radio>
                </RadioGroup>
              </Col>
              <Col span="13" style="padding-top: 33px">
                <Button type="primary" :loading="saving" size="small" @click="editBudget(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
              </Col>
            </Row>
            <div v-else>
              <span v-if="scope.row.budget > 0">{{ scope.row.budget | toThousands }}</span>
              <span v-else>不限</span>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row, 'editBudget', 'budget')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'day_budget_schedule'">
            <span>{{ scope.row[col.key] }}</span>
            <Icon
              v-if="scope.row.editState"
              type="md-create"
              class="g-pull-right m-edit"
              size="18"
              color="#409EFF"
              @click="changbudgetModel(scope.row)"
            />
          </div>
          <span v-else-if="col.key === 'originStatus'">{{ scope.row.originStatus | orStatus }}</span>
          <span v-else-if="col.key === 'adResourceId'">{{ adResource(scope.row.adResourceId) }}</span>
          <span v-else-if="col.key === 'adResource'">{{ adResource(scope.row.adResource) }}</span>
          <span v-else-if="col.key === 'planTime'">{{ scope.row | adTouTime(scope.row) }}</span>
          <span v-else-if="col.key === 'paperAmount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'pv'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'click'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'clickRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'perClickPrice'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thousandsOfDisplayCosts'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'convertNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'convertRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'budget'">{{ adBudget(scope.row.budget) | toThousands }}</span>
          <span v-else-if="col.key === 'landingType'">{{ scope.row.landingType | adLandType }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'synTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <betch-budget
      v-model="budgetModel"
      :data="budgets"
      :columns="budgetColumns"
      :type="budgetType"
      :account="budgetAccount"
      :id="budgetId"
      @refresh="$emit('on-refresh')"
    ></betch-budget>
    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns" @on-ok="$emit('on-refresh')"></betch-error>
  </div>
</template>
<script>
import mixin from './mixin'
import budgetColumns from '../data/budget.columns'
import { setLocalInfo, isEmpty, isArray, trim } from '@/common/js/utils'
import { toThousands } from '@/common/js/filters'
import { editGroupName, batchOperatorGroup, editPlanBudget, modifyBudget } from '@/api/convert.model'
import BetchError from '@/components/converter/betch-error.vue'
import BetchBudget from '@/components/converter/batch-budget.vue'
export default {
  name: 'groupTable',
  mixins: [mixin],
  components: {
    BetchError,
    BetchBudget
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    media: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  computed: {
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiao'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencent'
      else if (this.media === 45) name = 'create/baidu'
      else if (this.media === 32) name = 'create/kuaishou'
      return name
    },
    mediaTitle() {
      let title = []
      if ([10, 6].includes(this.media)) title = '计划组'
      else if ([16, 45, 32].includes(this.media)) title = '推广计划'
      return title
    }
  },
  methods: {
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      if (fixed) {
        val = val * 100
        val = Math.floor(val) / 100
      } else if ([16, 45, 32].includes(this.media)) {
        val = parseInt(val)
      }
      this.$set(row, key, val)
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    // 合计自定义
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let totalAmount = 0 // 总实际消耗
      let totalRegister = 0 // 总注册数
      let totalPaperAmount = 0 // 总账面消耗
      let totalConverterNum = 0 // 总转化数
      let convertCostIndex // 转化成本索引
      let registerCostIndex // 注册成本索引
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[prop]))
        if (
          [
            'paperAmount',
            'amount',
            'pv',
            'click',
            'activeNum',
            'convertNum',
            'convertCost',
            'register',
            'registerCost',
            'payCount',
            'payAmount',
            'appCheckoutCount'
          ].includes(prop) &&
          !values.every((value) => isNaN(value))
        ) {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          // 用于求平均注册、转化成本
          if (column.property === 'amount') totalAmount = sum
          if (column.property === 'register') totalRegister = sum
          if (column.property === 'paperAmount') totalPaperAmount = sum
          if (column.property === 'convertNum') totalConverterNum = sum
          if (prop === 'convertCost') convertCostIndex = index
          if (prop === 'registerCost') registerCostIndex = index
          sums[index] = sum.toString().includes('.') ? toThousands(parseFloat(sum.toFixed(2))) : toThousands(sum)
        } else {
          sums[index] = ''
        }
      })
      sums[convertCostIndex] = totalConverterNum ? parseFloat(totalPaperAmount / totalConverterNum).toFixed(2) : totalPaperAmount.toFixed(2)
      sums[registerCostIndex] = totalRegister ? parseFloat(totalAmount / totalRegister).toFixed(2) : totalRegister
      return sums
    },
    // 修改跳转
    editClick(row) {
      setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
      window.open(`/${this.mediaHtml}/group?id=${row.adGroupId}&t=edit`, '_blank')
    },
    // 复制跳转
    copyClick(row) {
      setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
      window.open(`/${this.mediaHtml}/group?id=${row.adGroupId}`, '_blank')
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },
    // 改变编辑状态
    changEdit(row, key, feild) {
      if (!key) {
        this.data.forEach((ret) => {
          this.$set(ret, 'edit', false)
        })
        this.$set(row, 'newAdGroupName', row.adGroupName)
        this.$set(row, 'edit', true)
      } else {
        const value = row[feild]
        this.data.forEach((ret) => {
          this.$set(ret, key, false)
        })
        this.$set(row, `new${feild}`, value)
        this.$set(row, key, true)
      }
    },
    cancelEdit(row, key) {
      if (!key) {
        this.saving = false
        this.$set(row, 'edit', false)
      } else {
        this.saving = false
        this.$set(row, key, false)
      }
    },
    changbudgetModel(row) {
      let budgetSchedule = [{ mon: 0, tue: 0, wed: 0, thur: 0, fri: 0, sat: 0, sun: 0 }]
      const { day_budget_schedule, adAccountId, adGroupId } = row
      if (isArray(day_budget_schedule)) {
        const [mon, tue, wed, thur, fri, sat, sun] = day_budget_schedule
        budgetSchedule = [{ mon, tue, wed, thur, fri, sat, sun }]
      }
      this.budgets = budgetSchedule
      this.budgetModel = true
      this.budgetAccount = adAccountId
      this.budgetId = adGroupId
    },
    // 修改预算
    editBudget(row) {
      let budget = parseFloat(row.newbudget)
      let lowBudget // 最低预算

      // 不限
      if (row.budgetFlag) {
        if (this.media === 16) {
          const minBudget = 50
          const maxBudget = 40000000
          if (isNaN(budget)) {
            this.$Message.error({ duration: 3, content: '请输入数字' })
            return
          } else if (budget > maxBudget) {
            this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
            return
          } else if (budget < minBudget) {
            this.$Message.error({ duration: 5, content: `日预算应大于${minBudget}元` })
            return
          }
        } else if (this.media === 45) {
          const maxBudget = 9999999.99 // 最高日预算

          lowBudget = 50
          if (budget > maxBudget) {
            this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
            return
          }
          if (budget < lowBudget) {
            this.$Message.error({ duration: 5, content: `日预算应大于${lowBudget}元` })
            return
          }
        } else if (this.media === 32) {
          const maxBudget = 100000000 // 最高日预算
          lowBudget = 500
          if (budget > maxBudget) {
            this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
            return
          }
          if (budget < lowBudget) {
            this.$Message.error({ duration: 5, content: `日预算应大于${lowBudget}元` })
            return
          }
        }
      } else budget = 0

      const callback = (data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBudget', false)
          this.$emit('on-refresh')
        }
      }
      this.saving = true
      if (this.media === 32) {
        modifyBudget({ ad_account_id: row.adAccountId, adGroupId: row.adGroupId, day_budget: budget, bizType: 1 }).then(callback)
      } else {
        editPlanBudget({ adAccountId: row.adAccountId, adGroupId: row.adGroupId, newAdbudget: budget }).then(callback)
      }
    },
    // 修改广告组名称
    edit(row) {
      if (this.media === 16 && row.newAdGroupName.length * 3 > 110) {
        this.$Message.error({ duration: 5, content: '推广计划名称不能超过110个字符' })
        return
      }
      this.saving = true
      editGroupName({
        adAccountId: row.adAccountId,
        adGroupId: row.adGroupId,
        newAdGroupName: row.newAdGroupName
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'edit', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 开关
    changeActive(row) {
      let { status } = row
      status = status ? 1 : 2
      if ([1, 2].includes(status)) {
        row.optLoading = true
        this.betch(status, [row])
      }
    },
    select(val) {
      this.selectList = val
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何计划，请在列表中选择一个或多个计划再进行此操作。'
        })
        return
      }

      // 删除二次验证
      if (type < 0) {
        this.$Modal.confirm({
          title: '提示',
          content: `<p>当前选中${len}条计划组，确定删除吗？</p>`,
          onOk: () => {
            this.betch(type, this.selectList)
          }
        })
      } else {
        const seleIds = this.selectList.map((ret) => ret.adGroupId)
        this.data.forEach((ret) => {
          this.$set(ret, 'optLoading', seleIds.includes(ret.adGroupId))
        })
        this.betch(type, this.selectList)
      }
    },
    betch(type, row) {
      batchOperatorGroup({
        type,
        adGroups: row
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            // 显示错误列表
            this.betchErr = rows
            this.betchShow = true
            this.data.forEach((ret) => {
              this.$set(ret, 'optLoading', false)
            })
            return
          } else if (failNum && row.length === 1) {
            this.$Message.error({
              duration: 5,
              content: rows[0].result
            })
            this.$set(row, 'status', type === 2)
            this.$set(row, 'optLoading', false)
          } else {
            this.$Message.success({
              duration: 5,
              content: '操作成功'
            })
          }
          this.$emit('on-refresh')
        }
      })
    },
    // this在filters拿不到 只能用method
    adBudget(cellValue) {
      let cv
      if (this.media === 10) cv = 0
      else if (this.media === 6) cv = -1
      return cellValue === cv ? '不限' : cellValue
    },
    clickGroup(row) {
      const { adGroupId, adGroupName, adAccountId } = row
      if (this.media === 6) {
        this.$router.push({
          name: 'plan',
          query: {
            id: adGroupId,
            adAccountId: adAccountId
          }
        })
      } else {
        this.$store.commit('setIndexRoute', 'group')
        this.$router.push({
          name: 'advert',
          query: {
            media: this.media,
            id: adGroupId,
            name: encodeURI(adGroupName)
          }
        })
      }
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  filters: {
    adLandType: (cellValue) => {
      if (cellValue === 'APP') return '应用下载'
      else if (cellValue === 'LINK') return '销售线索收集'
      else if (cellValue === 'LIVE') return '直播间'
    },
    orStatus: (cellValue) => {
      let state
      switch (cellValue) {
        case 0:
          state = '启用'
          break
        case 1:
          state = '暂停'
          break
        case 2:
          state = '预算不足'
          break
        case 3:
          state = '不在推广期'
          break
        case 4:
          state = '账户预算不足'
          break
        case 5:
          state = '账户余额不足'
          break
        default:
          state = '未知'
          break
      }
      return state
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      selectList: [], // 选中
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      betchColumns: [],
      budgetModel: null,
      budgetId: '',
      budgetType: 1,
      budgetAccount: 0,
      budgetColumns: [],
      budgets: []
    }
  },
  created() {
    const s_max = 500
    this.budgetColumns = budgetColumns.map((ret) => {
      ret.render = (h, params) => {
        return h('InputNumber', {
          props: {
            step: 100,
            value: params.row[ret.key],
            min: s_max,
            max: 100000000
          },
          on: {
            'on-change': (event) => {
              this.budgets[params.index][ret.key] = event
            },
            'on-blur': () => {
              const event = params.row[ret.key]
              if (event && event < s_max) {
                this.$Message.warning(`分日预算最小值为 ${s_max}`)
                this.budgets[params.index][ret.key] = s_max
              } else if (event && event > 100000000) {
                this.$Message.warning('分日预算最大值为 100000000')
                this.budgets[params.index][ret.key] = 100000000
              }
            }
          },
          style: {
            width: '68px'
          }
        })
      }
      return ret
    })
  },
  mounted() {
    this.betchColumns = [
      {
        key: 'mediaName',
        title: '媒体名称',
        tooltip: true,
        minWidth: 100
      },
      {
        key: 'adGroupName',
        title: `${this.mediaTitle}名称`,
        tooltip: true,
        minWidth: 140
      },
      {
        key: 'result',
        title: '结果',
        tooltip: true,
        minWidth: 250
      }
    ]
  }
}
</script>
<style lang="scss" scoped>
.c-group-table {
  position: relative;
  background-color: #fff;

  .el-table {
    .m-control-btn {
      margin: 0;
      padding: 0 3px;
    }
  }
}
</style>
